import { render, staticRenderFns } from "./MessageOutgoingAudio.vue?vue&type=template&id=31b1bdf2&"
import script from "./MessageOutgoingAudio.vue?vue&type=script&lang=js&"
export * from "./MessageOutgoingAudio.vue?vue&type=script&lang=js&"
import style0 from "./MessageOutgoingAudio.vue?vue&type=style&index=0&id=31b1bdf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports